import Vue from 'vue'
import {AbilityBuilder, PureAbility} from '@casl/ability'

Vue.mixin({
  methods: {
    loadUserAuthorizations() {
      // New PureAbility starts with zero rules. Everything is denied by default
      const {can, cannot, rules} = new AbilityBuilder(PureAbility)
      const user = this.getLoggedInUser()

      // User not logged in
      if (!user) {
        this.cleanUserAuthorization()
        return
      }

      // Manage/all gives full rights to administrators
      if (user.role === 'administrator') {
        can('manage', 'all')
      }

      if (user.role === 'groupAdmin') {
        /*
         * Note: casl allows restricting fields by passing in a thrid param, however
         * this was throwing an error to pass in the 'fieldMatcher' option. We will
         * comeback and re factor this in the near future but for now, I'm using
         * 'role-admin' as the subject in this rule
         */
        cannot('update', 'role-admin')
        cannot('update', 'group')
        cannot('update', 'user-admins')
        can('update', 'group-users')
        can('update', 'user')
      }

      // Users won't have access to Link at all, adding it here just as a safe guard
      if (user.role === 'user') {
        cannot('manage', 'all')
      }

      // This call will update the global ability instance
      this.$ability.update(rules)
    },
    cleanUserAuthorization() {
      this.$ability.update(new PureAbility())
    },
  },
})
